module.exports = __webpack_public_path__ + "images/stickers/pete-confused@2x.7ff61659ad2cd4837aac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-confused@2x.png
// module id = tcc1
// module chunks = 13